// Shared constants exports

/**
 * Default placeholder shown when a trip has no cover photo.
 * Served from frontend/public so it needs no third-party request.
 */
export const DEFAULT_TRIP_COVER_URL = '/default-trip-cover.svg'
/**
 * Returns the trip cover URL to display, or the default cover when none is set.
 */
export function getTripCoverUrl(coverPhotoUrl: string | null | undefined): string {
  return coverPhotoUrl ?? DEFAULT_TRIP_COVER_URL
}
